var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mc-chips"},_vm._l((_vm.options),function(opt){return _c('button',{key:opt,staticClass:"mc-chip",class:{ 'is-on': _vm.isOn(opt) },attrs:{"type":"button"},on:{"click":function($event){return _vm.toggle(opt)}}},[_vm._v(" "+_vm._s(opt)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }